export function getLocationSearch() {
  return window.location.search;
}